import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { deleteIdData } from "../../../../lib/studentnotes";
//import { getStudentIdData } from "../../../../lib/studentnotes"
import { getInstructorStudent } from "../../../../lib/instructorstudentview";
import { getStudentIdData } from "../../../../lib/instructorstudentnotesview";

export default function InstructorStudentNotes({ slug }) {
  const [notes, setNotes] = useState([]);

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      //getDataWithTypeFromParamter();
      GetStudentData();
    }
  };

  /*
  async function GetAllData() {
    const note = await getInstructorData(profile.id);
    setNotes(note);
    console.log("note",note);
  }
  */

  async function GetStudentData() {
    const note = await getStudentIdData(slug);
    setNotes(note);
    console.log("getStudentIdData", note);
  }

  useEffect(() => {
    GetStudentData();
  }, []);

  return (
    <div className="settings-widget profile-details">
      <div className="settings-inner-blk p-0">
        <div className="profile-heading">
          <h3>Notes</h3>
          <div className="new-address">
            <div className="row">
              <div className="col"></div>
              <div className="col"> </div>
              <div className="col">
                <Link
                  to={`/instructor/instructor-notes-edit/Add/${slug}/Student`}
                  className={`btn btn-dark btn-dark-1`}
                >
                  Add New Note
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="category-tab tickets-tab-blk"></div>
        <div className="comman-space pb-0">
          <div className="settings-invoice-blk table-responsive">
            {/* Invoice info */}
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Regarding</th>
                  <th>Student</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {notes.map(function (data) {
                  return (
                    <tr key={data.id}>
                      <td>
                        <Link to="#" className="invoice-no">
                          {data.id}
                        </Link>
                      </td>
                      <td>{data.title}</td>
                      <td>{data.name + " " + data.surname}</td>
                      <td>
                        <div className="profile-share d-flex align-items-center justify-content-end">
                          <Link
                            to={`/instructor/instructor-notes-edit/Update/${data.id}/Student`}
                            className="btn btn-success btn-sm"
                          >
                            Update
                          </Link>

                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(data.id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {/* Invoice info */}
          </div>
        </div>
      </div>
    </div>
  );
}
